import gsap from 'gsap';
import { ease1 } from '../../easings';

const ANIMATION_SELECTORS = {
    TITLE: '.js-p-title',
    HEADER_ACTIONS: '.js-p-header-actions',
    CONTENT_ELEMENT: '.js-p-content-element',
};

const init = () => {
    const firstViewportTimeline = gsap.timeline({ defaults: { duration: 1, ease: ease1 } });

    firstViewportTimeline
        .fromTo(ANIMATION_SELECTORS.TITLE, { yPercent: 80 }, { yPercent: 0, opacity: 1 })
        .to(ANIMATION_SELECTORS.HEADER_ACTIONS, { opacity: 1 }, '-=0.4')
        .to(ANIMATION_SELECTORS.CONTENT_ELEMENT, { opacity: 1, stagger: 0.4 }, '-=1');
};

const _module = { init };

export default _module;
